import React from "react";
import { Box, styled } from "@mui/material";

// Optional: styled component if you want hover/color customization
const StyledHr = styled(Box)(({ color = "var(--gray-300)", thickness = "1px", width = "100%", margin = "16px 0" }) => ({
  borderTop: `${thickness} solid ${color}`,
  width: width,
  margin: margin,
}));

export default function Hr({
  color = "var(--gray-300)",
  thickness = "1px",
  width = "100%",
  margin = "16px 0",
  sx = {},
}) {
  return (
    <StyledHr
      color={color}
      thickness={thickness}
      width={width}
      margin={margin}
      sx={{ ...sx }}
    />
  );
}

